import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IObjectCustomFields } from 'src/app/features/settings/models/settings.models';
import { ObjectCustomFieldsFormComponent } from 'src/app/shared/components/object-custom-fields-form/object-custom-fields-form.component';

@Component({
  selector: 'app-customer-custom-fields',
  templateUrl: './customer-custom-fields.component.html',
  styleUrls: ['./customer-custom-fields.component.scss']
})
export class CustomerCustomFieldsComponent implements OnInit {
  @ViewChild(ObjectCustomFieldsFormComponent) customFieldsForm?: ObjectCustomFieldsFormComponent;

  constructor(
    public dialogRef: MatDialogRef<CustomerCustomFieldsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { objectCustomFields: IObjectCustomFields },
  ) { }

  ngOnInit(): void { }

  cancel(): void {
    this.dialogRef.close();
  }

  save(): void {
    this.customFieldsForm?.onSave();
  }

  saveCustomerCustomFields(values: IObjectCustomFields['values']): void {
    this.dialogRef.close(values);
  }

}
